import React, { useState, useEffect } from 'react';

import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';

import Button from '@mui/material/Button';

import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Snackbar from '@mui/material/Snackbar';
import CloseIcon from '@mui/icons-material/Close';

import IconButton from '@mui/material/IconButton';

import DeleteIcon from '@mui/icons-material/Delete';

import Refresh from '@mui/icons-material/Refresh'

import GenericUpload from './GenericUpload';
import CustomButton from './CustomButton';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import FormControlLabel from '@mui/material/FormControlLabel';

import {
    DataGrid,
    gridPageCountSelector,
    gridPageSelector,
    useGridApiContext,
    useGridSelector,
    GridOverlay,
    GridToolbar,
    GridToolbarContainer,
    GridToolbarColumnsButton,
    GridToolbarFilterButton,
    GridToolbarExport,
    GridToolbarDensitySelector,
    GridToolbarQuickFilter
} from '@mui/x-data-grid';

import Pagination from '@mui/material/Pagination';
import Primarytheme from './theme';

import { getSessionIdToken } from '../auth/apiAuth'

import axios from 'axios';

const {
    REACT_APP_USER_ID,
} = process.env;

/* function CustomPagination() {
    const apiRef = useGridApiContext();
    const page = useGridSelector(apiRef, gridPageSelector);
    const pageCount = useGridSelector(apiRef, gridPageCountSelector);

    if (pageCount > 1) return (
        <Pagination
            color="primary"
            count={pageCount}
            page={page + 1}
            onChange={(event, value) => apiRef.current.setPage(value - 1)}

        />
    )
    else return null
} */


export default function AssetImage({ auth, conf, dataTable, folderObjList, handleRefreshTable, inDashboard = false }) {

    //console.log('asset folders obj list', folderObjList)
    const [selectionModel, setSelectionModel] = useState([]);

    // messagge many items to delete
    const [openAsset, setOpenAsset] = useState(false);

    const handleCloseAsset = (event, reason) => {
        setOpenAsset(false);
    };

    const hasLastUsedProperty = (dataTable && dataTable.rows) ? dataTable.rows.some(obj => obj.hasOwnProperty('Last Used')) : false;

    const [openBulkDialog, setOpenBulkDialog] = useState(false);
    const [bulkPreset, setBulkPreset] = useState('1y');
    const [bulkCustomDays, setBulkCustomDays] = useState(365);
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
    const [confirmText, setConfirmText] = useState('');

    const computeUnusedFiles = (days) => {
        if (!dataTable?.rows) return [];
        const currentDate = new Date();
        return dataTable.rows.filter((item) => {
            if (!item['Last Used'] || isNaN(new Date(item['Last Used']).getTime())) return false;
            const differenceInDays = Math.floor((currentDate - new Date(item['Last Used'])) / (1000 * 60 * 60 * 24));
            return differenceInDays >= days;
        });
    };

    const bulkDays = bulkPreset === '6m' ? 183 : bulkPreset === '1y' ? 365 : bulkPreset === '2y' ? 730 : (Number(bulkCustomDays) || 1);
    const bulkPreviewCount = computeUnusedFiles(bulkDays).length;

    const handleSelectedRows = ({ selection }) => {
        setSelectionModel(selection)
        //console.log('selectionModel ', selectionModel)
    }

    const deleteFileS3 = async ({ keyList, manyItemsFlag }) => {
        const name = dataTable.name;
        const sharedProjectId = folderObjList.filter(obj => obj.name === name)[0].sharedProjectId;

        // console.log('delete ', keyList)
        if (manyItemsFlag) setOpenAsset(true);

        let dynamoArrRequest = [];
        for (let i = 0; i < keyList.length; i++) {
            dynamoArrRequest.push(keyList[i]);

            if (i % 25 === 0 || i === keyList.length - 1) {
                const delReq = await axios({
                    method: "post",
                    url: `${process.env.REACT_APP_API_BASE_URL}/assets`,
                    headers: {
                        'user_id': REACT_APP_USER_ID || auth.userState.ssmParams.USER_ID,
                        "content-type": "application/json",
                        "Authorization": await getSessionIdToken(),
                        "action": "delete-batch"
                    },
                    data: { keyList: dynamoArrRequest, manyitemsflag: manyItemsFlag, sharedProjectId }
                })
                //console.log('resp delete:', i, delReq)

                dynamoArrRequest = [];
            }

        }

        setSelectionModel([]);
        // refresh!!
        await new Promise(resolve => setTimeout(resolve, 1000));
        await handleRefreshTable()
        setOpenAsset(false)
    }

    const deleteUnusedFileS3 = async ({ days }) => {
        const keyList = computeUnusedFiles(days);
        await deleteFileS3({ keyList: keyList.map((idRow) => `${idRow.bucket}###${idRow.key}`), manyItemsFlag: keyList.length > 100 });
    }

    const [openDelete, setOpenDelete] = React.useState(false);
    const handleClickOpenDelete = () => {
        setOpenDelete(true);
    };
    const handleCloseDelete = () => {
        setOpenDelete(false);
    };


    const [openDeletedSnack, setOpenDeletedSnack] = React.useState(false);
    const handleOpenDeletedSnack = () => {
        setOpenDeletedSnack(true);
    };
    const handleCloseDeletedSnack = () => {
        setOpenDeletedSnack(false);
    };

    const columnsWithQuickFilter = !inDashboard ? dataTable.columns.map((col, index, arr) => ({
        ...col,
        flex: index === 0 ? 10 : (col.flex || 1),
        minWidth: index === 0 ? 150 : (index === arr.length - 1 ? 160 : 100),
        width: undefined,
        getApplyQuickFilterFn: index === 0 ? undefined : () => null,
    })) : undefined


    const CustomToolbar = () => {
        return (
            <Stack direction='row' justifyContent="space-between" alignItems="center" mb='1em' flexWrap='wrap' gap={1}>
                <Stack direction='row' spacing={2} justifyContent="space-between" alignItems="center">
                    <GridToolbarQuickFilter
                        quickFilterParser={(searchInput) =>
                            searchInput
                                .split(',')
                                .map((value) => value.trim())
                                .filter((value) => value !== '')
                        }
                        sx={{ minWidth: '200px' }}
                    />
                    <Typography variant='body2' >
                        items: {dataTable.nItems}
                    </Typography>
                    <Typography variant='body2'  >
                        total size: {(dataTable.size >= 1073741824) ? Number(dataTable.size / 1073741824).toFixed(2) + ' GB' : Math.round(dataTable.size / 1048576) + ' MB'}
                    </Typography>
                </Stack>


                <Stack direction='row' spacing={3} justifyContent='flex-end' alignItems='center' >
                    <Stack direction='row' spacing={1} justifyContent='flex-end' alignItems='center' >
                        <GridToolbarColumnsButton sx={{ pt: 0.3, pb: 0.3, color: Primarytheme.palette.neutral.main, ":hover": { color: Primarytheme.palette.primary.main }, border: '1px solid' }} />
                        <GridToolbarFilterButton sx={{ pt: 0.3, pb: 0.3, color: Primarytheme.palette.neutral.main, ":hover": { color: Primarytheme.palette.primary.main }, border: '1px solid' }} />
                        <GridToolbarDensitySelector sx={{ pt: 0.3, pb: 0.3, color: Primarytheme.palette.neutral.main, ":hover": { color: Primarytheme.palette.primary.main }, border: '1px solid' }} />
                        <GridToolbarExport sx={{ pt: 0.3, pb: 0.3, color: Primarytheme.palette.neutral.main, ":hover": { color: Primarytheme.palette.primary.main }, border: '1px solid' }} />
                    </Stack>
                    <Stack direction='row' spacing={1} justifyContent='flex-end' alignItems='center' >
                        {!hasLastUsedProperty && <Button
                            onClick={async () => handleClickOpenDelete()}
                            variant='contained'
                            size='small'
                            startIcon={<DeleteIcon />}
                            disabled={selectionModel.length === 0}
                        >
                            Delete
                        </Button>}
                        {hasLastUsedProperty && <CustomButton mainLabel='Delete' mainIcon={<DeleteIcon />}
                            optionArr={[
                                { desc: 'Delete selected items', icon: null, disabled: selectionModel.length === 0, func: async () => await deleteFileS3({ keyList: selectionModel.map((idRow) => `${conf.bucket}###${idRow}`), manyItemsFlag: selectionModel.length > 100 }) },
                                { desc: 'Bulk Deletion', icon: null, func: () => { setBulkPreset('1y'); setBulkCustomDays(365); setConfirmText(''); setOpenBulkDialog(true); } },
                            ]}
                        />}
                        <IconButton onClick={handleRefreshTable} > <Refresh /> </IconButton>
                    </Stack>
                </Stack>
            </Stack >


        );
    }

    return (
        <Stack direction='column' spacing={2} mt={inDashboard ? 0 : '1em'} >
            <Card elevation={inDashboard ? 0 : 1}>
                <CardContent sx={{ '&:last-child': { m: inDashboard ? 0 : undefined, p: inDashboard ? 0 : undefined, paddingBottom: '0.5em' } }}>
                    {!inDashboard &&
                        <Typography component='div' variant='body' color='primary' sx={{ mb: '1em' }}>
                            <b>Upload New {dataTable.name}</b>
                        </Typography>
                    }

                    <GenericUpload
                        auth={auth.userState}
                        bucket={conf.customBucket ? conf.customBucket : conf.bucket}
                        project_id={conf.project_id}
                        folderObjList={folderObjList}
                        selectedFolder={dataTable.name}
                        refresh={handleRefreshTable}
                        direction={inDashboard ? 'column' : 'row'}
                    />

                </CardContent>
            </Card >

            {!inDashboard && (
                <Card>
                    <CardContent sx={{
                        '&:</CardContent>last-child': { paddingBottom: '0.5em' },
                        overflowX: 'auto',
                        /* '& .MuiDataGrid-root': {
                            minWidth: 'max-content',
                        }, */
                    }}>
                        <Typography component='div' variant='body' color='primary' >
                            <b>Explore {dataTable.name}</b>
                        </Typography>

                        <DataGrid
                            key={dataTable.name}
                            rows={dataTable.rows}
                            columns={columnsWithQuickFilter}
                            autoHeight

                            checkboxSelection

                            initialState={{
                                pagination: {
                                    paginationModel: {
                                        pageSize: 10

                                    }
                                }
                            }}
                            pageSizeOptions={[10, 20, 50]}

                            onRowSelectionModelChange={(selection) => handleSelectedRows({ selection })}
                            rowSelectionModel={selectionModel}
                            slots={{
                                //pagination: CustomPagination,
                                toolbar: CustomToolbar,

                            }}

                            sx={{
                                border: '0px',
                                '& .MuiDataGrid-columnHeader:focus': { outline: 'none' },
                                '& .MuiDataGrid-cell:focus': { outline: 'none' },
                                '& .MuiDataGrid-columnHeaderCheckbox:focus': { outline: 'none' },
                                '& .MuiDataGrid-cellCheckbox': { outline: 'none', color: 'red' },
                                '& .MuiDataGrid-cell': {
                                    display: 'flex',
                                    alignItems: 'center', // vertical alignment
                                },
                            }}
                        />
                    </CardContent>
                    <Dialog
                        open={openDelete}
                        onClose={handleCloseDelete}
                        aria-labelledby="Confirm delete"
                        aria-describedby="Confirm Delete"
                    >
                        <DialogTitle id="confirm-delete">
                            {"Confirm Deletion"}
                        </DialogTitle>
                        <DialogContent>
                            <DialogContentText id="confirm-delete-description">
                                Are you sure you want to delete selected assets? This action won't be undoable.
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handleCloseDelete}>Cancel</Button>
                            <Button onClick={async () => {
                                handleCloseDelete()
                                await deleteFileS3({ keyList: selectionModel.map((idRow) => `${conf.bucket}###${idRow}`), manyItemsFlag: selectionModel.length > 100 ? true : false })
                                handleOpenDeletedSnack()
                            }} autoFocus>
                                <Typography sx={{ color: 'red' }}>Yes</Typography>
                            </Button>
                        </DialogActions>
                    </Dialog>

                    <Dialog open={openBulkDialog} onClose={() => setOpenBulkDialog(false)} maxWidth='xs' fullWidth>
                        <DialogTitle>Bulk Deletion</DialogTitle>
                        <DialogContent>
                            <FormControl component='fieldset' sx={{ width: '100%' }}>
                                <FormLabel component='legend'>Delete files unused for at least:</FormLabel>
                                <RadioGroup value={bulkPreset} onChange={(e) => setBulkPreset(e.target.value)} sx={{ mt: 1 }}>
                                    <FormControlLabel value='6m' control={<Radio size='small' />} label='6 Months' />
                                    <FormControlLabel value='1y' control={<Radio size='small' />} label='1 Year' />
                                    <FormControlLabel value='2y' control={<Radio size='small' />} label='2 Years' />
                                    <FormControlLabel value='custom' control={<Radio size='small' />} label='Custom' />
                                </RadioGroup>
                            </FormControl>
                            {bulkPreset === 'custom' && (
                                <TextField
                                    label='Days'
                                    type='number'
                                    size='small'
                                    value={bulkCustomDays}
                                    onChange={(e) => setBulkCustomDays(Math.max(1, parseInt(e.target.value) || 1))}
                                    inputProps={{ min: 1 }}
                                    sx={{ mt: 1, width: '120px' }}
                                />
                            )}
                            <Typography variant='body2' sx={{ mt: 2, color: bulkPreviewCount === 0 ? 'text.secondary' : 'error.main' }}>
                                {bulkPreviewCount} file{bulkPreviewCount !== 1 ? 's' : ''} will be deleted
                            </Typography>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => setOpenBulkDialog(false)}>Cancel</Button>
                            <Button
                                disabled={bulkPreviewCount === 0}
                                onClick={() => { setOpenBulkDialog(false); setConfirmText(''); setOpenConfirmDialog(true); }}
                                variant='contained'
                            >
                                Next
                            </Button>
                        </DialogActions>
                    </Dialog>

                    <Dialog open={openConfirmDialog} onClose={() => setOpenConfirmDialog(false)} maxWidth='xs' fullWidth>
                        <DialogTitle>Confirm Bulk Deletion</DialogTitle>
                        <DialogContent>
                            <DialogContentText>
                                You are about to permanently delete <strong>{bulkPreviewCount} file{bulkPreviewCount !== 1 ? 's' : ''}</strong>. This action cannot be undone.
                            </DialogContentText>
                            <TextField
                                label='Type DELETE to confirm'
                                size='small'
                                value={confirmText}
                                onChange={(e) => setConfirmText(e.target.value)}
                                sx={{ mt: 2, width: '100%' }}
                            />
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => setOpenConfirmDialog(false)}>Cancel</Button>
                            <Button
                                disabled={confirmText !== 'DELETE'}
                                onClick={async () => { setOpenConfirmDialog(false); await deleteUnusedFileS3({ days: bulkDays }); }}
                                variant='contained'
                                color='error'
                            >
                                Proceed
                            </Button>
                        </DialogActions>
                    </Dialog>

                    <Snackbar
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'left',
                        }}
                        open={openDeletedSnack}
                        autoHideDuration={6000}
                        onClose={handleCloseDeletedSnack}
                        message='Assets deleted'
                        action={
                            <React.Fragment>
                                <IconButton size="small" aria-label="close" color="inherit" onClick={handleCloseDeletedSnack}>
                                    <CloseIcon fontSize="small" />
                                </IconButton>
                            </React.Fragment>
                        }
                    />
                </Card >
            )}

            <Snackbar
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                open={openAsset}
                //autoHideDuration={6000}
                onClose={handleCloseAsset}
                message='We are deleting many files. If the process stops, reload the page and try again.'
                action={
                    <React.Fragment>
                        <IconButton size="small" aria-label="close" color="inherit" onClick={handleCloseAsset}>
                            <CloseIcon fontSize="small" />
                        </IconButton>
                    </React.Fragment>
                }
            />
        </Stack>
    )


}